(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('VirtualNumberDeleteController',VirtualNumberDeleteController);

    VirtualNumberDeleteController.$inject = ['$uibModalInstance', 'entity', 'VirtualNumber'];

    function VirtualNumberDeleteController($uibModalInstance, entity, VirtualNumber) {
        var vm = this;

        vm.virtualNumber = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VirtualNumber.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
